import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

function Download() {
  const url = window.location.href.replace('/download', '/v1/ipa/manifest.plist');
  return (
    <Grid container alignItems='center' justifyContent='center' direction='column' spacing={3}>
      <Grid item>
        <Typography align='center' variant='h4'>つうトレアプリダウンロードサイト</Typography>
      </Grid>
      <Grid item sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box component='img' alt='アイコン' src='app/512.png' sx={{ width: '25%', height: '25%' }}/>
      </Grid>
      <Grid item>
        <Button variant='contained' color='primary' component={Link}
          to={'itms-services://?action=download-manifest&url=' + url}
        >
          アプリをインストール
        </Button>
      </Grid>
    </Grid>
  );
}

export default Download;
